import { render, staticRenderFns } from "./ListDealTypes.vue?vue&type=template&id=a886171a"
import script from "./ListDealTypes.vue?vue&type=script&lang=js"
export * from "./ListDealTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports